import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import { onChange, resetCrud } from 'portaltransparencia-common/crud/Actions.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import { fromJS, List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react';
import * as actions from './Actions.js';
import EmendaTable from './Table.react.js';
import FormFilter from './FormFilter.react.js';
import UltimaAtualizacaoByTable from '../ultimaatualizacao/UltimaAtualizacaoByTable.react';
import {
  findDataAtualizacaoEmendasEstaduais,
  findDataAtualizacaoEmendasFederais,
  findDataAtualizacaoEmendasMunicipais
} from '../ultimaatualizacao/Actions';
import { TipoEmendaParlamentar } from './TipoEmendaParlamentar';
import { addPagination } from 'portaltransparencia-common/libs/AddFilter';
import { buildParamsQuery } from './UrlFilter';

const FILTER_KEY = {
  [TipoEmendaParlamentar.MUNICIPAL]: 'filtroEmendasMunicipais',
  [TipoEmendaParlamentar.FEDERAL]: 'filtroEmendasFederais',
  [TipoEmendaParlamentar.ESTADUAL]: 'filtroEmendasEstaduais'
};

const LABEL = {
  [TipoEmendaParlamentar.MUNICIPAL]: 'Municipais',
  [TipoEmendaParlamentar.FEDERAL]: 'Federais',
  [TipoEmendaParlamentar.ESTADUAL]: 'Estaduais'
};

const ROUTE = {
  [TipoEmendaParlamentar.MUNICIPAL]: 'municipais',
  [TipoEmendaParlamentar.FEDERAL]: 'federais',
  [TipoEmendaParlamentar.ESTADUAL]: 'estaduais'
};

export class FormEmendaContabilidade extends Component {
  static propTypes = {
    page: PropTypes.instanceOf(Map).isRequired,
    filtros: PropTypes.instanceOf(Map),
    location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
    history: PropTypes.shape({ push: PropTypes.func }).isRequired,
    tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
    findEmendasMunicipais: PropTypes.func.isRequired,
    findEmendasMunicipaisTotal: PropTypes.func.isRequired,
    findEmendasFederais: PropTypes.func.isRequired,
    findEmendasFederaisTotal: PropTypes.func.isRequired,
    findEmendasEstaduais: PropTypes.func.isRequired,
    findEmendasEstaduaisTotal: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    resetCrud: PropTypes.func.isRequired,
    addErrorNotification: PropTypes.func.isRequired,
    tiposTransferencias: PropTypes.instanceOf(List),
    tiposOrigens: PropTypes.instanceOf(List),
    findTiposTransferencias: PropTypes.func.isRequired,
    findTiposOrigens: PropTypes.func.isRequired,
    findDataAtualizacaoEmendasMunicipais: PropTypes.func,
    findDataAtualizacaoEmendasFederais: PropTypes.func,
    findDataAtualizacaoEmendasEstaduais: PropTypes.func,
    totalizador: PropTypes.instanceOf(Map),
    dateAtt: PropTypes.string
  };

  state = {
    exibeDesdobramento: false,
    currentSort: null
  };

  panelFiltro = createRef();

  isEmendaFederal() {
    return this.props.tipo === TipoEmendaParlamentar.FEDERAL;
  }

  isEmendaEstadual() {
    return this.props.tipo === TipoEmendaParlamentar.ESTADUAL;
  }

  findEmendas(filtros, page) {
    const {
      findEmendasMunicipais,
      findEmendasMunicipaisTotal,
      findEmendasFederais,
      findEmendasFederaisTotal,
      findEmendasEstaduais,
      findEmendasEstaduaisTotal
    } = this.props;

    if (this.isEmendaFederal()) {
      findEmendasFederaisTotal(filtros);
      return findEmendasFederais(filtros, page);
    }

    if (this.isEmendaEstadual()) {
      findEmendasEstaduaisTotal(filtros);
      return findEmendasEstaduais(filtros, page);
    }

    findEmendasMunicipaisTotal(filtros);
    return findEmendasMunicipais(filtros, page);
  }

  componentDidMount() {
    const {
      findDataAtualizacaoEmendasMunicipais,
      findDataAtualizacaoEmendasFederais,
      findDataAtualizacaoEmendasEstaduais
    } = this.props;

    if (this.isEmendaFederal()) {
      findDataAtualizacaoEmendasFederais();
    } else if (this.isEmendaEstadual()) {
      findDataAtualizacaoEmendasEstaduais();
    } else {
      findDataAtualizacaoEmendasMunicipais();
    }

    this.onResetFiltro();
    this.props.findTiposTransferencias();
    this.props.findTiposOrigens();
  }

  onChangeFiltro = event => {
    this.props.onChange(FILTER_KEY[this.props.tipo], event);
  };

  onResetFiltro = () => {
    const { resetCrud, page } = this.props;
    this.setState({ exibeDesdobramento: false });
    resetCrud(FILTER_KEY[this.props.tipo]);
    this.findEmendas(Map({}), page);
  };

  onConsulta = event => {
    event && event.preventDefault();
    const { page } = this.props;
    this.searchWithPage(page.set('number', 0));
    this.panelFiltro.current && this.panelFiltro.current.collapse();
  };

  searchWithPage = page => {
    const { filtros } = this.props;
    const sort = page.get('sort');
    if (sort && typeof sort === 'string') {
      const [property, direction] = sort.split(',');
      this.setState({ currentSort: [{ property, direction }] });
    }
    this.findEmendas(filtros || Map({}), page);
  };

  exportPage = (exportType, openTab, windowParams) => {
    const { page, filtros, addErrorNotification } = this.props;
    const { currentSort } = this.state;
    const { apiURL } = configuration;

    if (page.get('content', List()).isEmpty()) {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
      return;
    }

    const { entidade, exercicio } = StorageService.getItem('userInfo');

    const paramsExport = new URLSearchParams({
      entidade: entidade.id,
      exercicio: exercicio.id,
      exportType
    });

    const sortQuery = currentSort
      ? addPagination(Map({ sort: fromJS(currentSort) }))
      : '';

    const urlParams = [
      paramsExport.toString(),
      buildParamsQuery(filtros),
      sortQuery
    ]
      .filter(Boolean)
      .join('&');

    window.open(
      `${apiURL}/api/emendas-parlamentares/contabilidade/report/${
        ROUTE[this.props.tipo]
      }?${urlParams}`,
      openTab,
      windowParams
    );
  };

  onMoreEmenda = item => {
    const basePath = ROUTE[this.props.tipo];
    this.props.history.push(`emendas-${basePath}/${item.get('id')}`);
  };

  render() {
    const {
      page,
      filtros,
      location,
      dateAtt,
      totalizador,
      tiposTransferencias,
      tiposOrigens,
      tipo
    } = this.props;
    const tipoLabel = LABEL[tipo];

    const { currentSort } = this.state;
    const pageEmendas = currentSort
      ? page.set('sort', fromJS(currentSort))
      : page;

    return (
      <section>
        <PageHeader location={location} />

        <NotasExplicativas pathname={location.pathname} />

        <Panel
          title={`Consultar em Emendas ${tipoLabel}`}
          isForm
          mobileClose
          ref={this.panelFiltro}
        >
          <FormFilter
            filtros={filtros}
            onConsulta={this.onConsulta}
            onReset={this.onResetFiltro}
            onChange={this.onChangeFiltro}
            tiposTransferencias={tiposTransferencias}
            tiposOrigens={tiposOrigens}
            tipo={tipo}
          />
        </Panel>

        <Panel isForm tableResponsive expansible={false}>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacaoByTable
                modulo="3"
                table="emendaParlamentar"
                column="dataultimaatualizacao"
                dateAtt={dateAtt}
              />
            </Col>
            <Col xs={6}>
              <ExportButtonGroup onClick={this.exportPage} />
            </Col>
          </Row>

          <EmendaTable
            tipo={tipo}
            page={pageEmendas}
            totalizador={totalizador || Map({})}
            searchWithPage={this.searchWithPage}
            onMore={this.onMoreEmenda}
            tipoLabel={tipoLabel}
          />

          <div style={{ marginTop: -20 }}>
            <SearchPagination
              page={pageEmendas}
              searchWithPage={this.searchWithPage}
            />
          </div>
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { tipo } = ownProps;
  const filterKey = FILTER_KEY[tipo];

  return {
    page: state.emendaContabilidade.get('emendas'),
    totalizador: state.emendaContabilidade.get('totalizador', Map({})),
    filtros: state.crud.getIn([filterKey, 'currentRecord'], Map({})),
    tiposTransferencias: state.emendaContabilidade.get(
      'tiposTransferencias',
      List()
    ),
    tiposOrigens: state.emendaContabilidade.get('tiposOrigens', List()),
    dateAtt: state.ultimaAtualizacao.get('dateAtt')
  };
}

const allActions = {
  findEmendasMunicipais: actions.findEmendasMunicipais,
  findEmendasMunicipaisTotal: actions.findEmendasMunicipaisTotal,
  findEmendasFederais: actions.findEmendasFederais,
  findEmendasFederaisTotal: actions.findEmendasFederaisTotal,
  findEmendasEstaduais: actions.findEmendasEstaduais,
  findEmendasEstaduaisTotal: actions.findEmendasEstaduaisTotal,
  findTiposTransferencias: actions.findTiposTransferencias,
  findTiposOrigens: actions.findTiposOrigens,
  onChange,
  resetCrud,
  addErrorNotification,
  findDataAtualizacaoEmendasMunicipais,
  findDataAtualizacaoEmendasFederais,
  findDataAtualizacaoEmendasEstaduais
};

export default connect(mapStateToProps, allActions)(FormEmendaContabilidade);
